import sessionStore from 'store/session';
import { get } from 'svelte/store';

const formatNumber = (number) => {
    // if it starts with +234, remove the +234 and replace with 0
    // if it starts with 234, remove the 234 and replace with 0
    // if it starts with 0, leave it as it is
    // if it doesn't start with 0, add 0 to the beginning

    if (number.startsWith('+234')) {
        return number.replace('+234', '0');
    } else if (number.startsWith('234')) {
        return number.replace('234', '0');
    } else if (!number.startsWith('0')) {
        return `0${number}`;
    } else {
        return number;
    }
};

let CONTACT_CACHE = {};

export const getContactName = (number) => {
    if (CONTACT_CACHE[number]) {
        return CONTACT_CACHE[number];
    }

    const contacts = get(sessionStore).contacts;

    let numberToCompare = formatNumber(number);

    const contact = contacts.find((contact) => {
        return contact.contact_number === numberToCompare;
    });

    CONTACT_CACHE[number] = contact ? contact.contact_name : number;

    return CONTACT_CACHE[number];
};
